function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import FilterDropdown from './filter-dropdown';
import FilterFieldToggler from './filter-field-toggler';
import rangeSlider from './rangeSlider';
import MultipleFilterProduct from '../services/MultipleFilterProduct';
import { getCountryPrice } from "./countryPrice";
var actions = {
  filterproduct: 'filterproduct',
  moreproduct: 'moreproduct'
};
var multiFilterInstanse = new MultipleFilterProduct({
  container: '.js-loadmore-wrapper',
  founded: '.js-ajax-product-number'
});
function getInputsValues(fields, attrValue) {
  if (fields === null) return [];
  return Array.prototype.map.call(fields, function (field) {
    if (field === null) return;
    return field[attrValue];
  });
}
function getValuesFromFields() {
  return {
    inputsCheckbox: document.querySelectorAll(".js-filter-field input[type=checkbox]:checked"),
    //cat: document.querySelector(`.js-filter-field input[type=radio]:checked`),
    cat: document.querySelector(".js-filter-category.active").getAttribute('data-category-id'),
    inputMin: document.querySelector('.range-slider__field-min').value,
    inputMax: document.querySelector('.range-slider__field-max').value
  };
}
function init() {
  var container = document.querySelector('.js-filter-products-wrapper');
  var loadmoreContainer = document.querySelector('.js-loadmore-wrapper');
  var loadmoreSelector = 'js-filter-load-more';
  if (!container) return;
  var filterFieldToggler = new FilterFieldToggler({
    selector: 'js-filter-field'
  });
  var filterDropdown = new FilterDropdown({
    container: '.js-filter-select',
    opener: '.js-filter-tab-opener',
    dropdown: '.js-filter-tab-dropdown',
    linkSelector: '.js-filter-tab-link'
  });
  filterDropdown.init();
  filterFieldToggler.handleClickOnFilter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      inputsCheckbox = _ref2[0],
      inputRadio = _ref2[1];
    var _getValuesFromFields = getValuesFromFields(),
      inputMin = _getValuesFromFields.inputMin,
      inputMax = _getValuesFromFields.inputMax;
    var designers = getInputsValues(inputsCheckbox, 'name');
    filterDropdown.setOptionByName(inputRadio && inputRadio.value);
    var params = {
      designers: designers,
      inputMin: inputMin,
      inputMax: inputMax,
      cat: inputRadio && inputRadio.value
    };
    multiFilterInstanse.ajaxFilterProducts(actions.filterproduct, filter_params.ajax_nonce, params);
  });
  filterDropdown.handleClickOnOption(function (value, attr) {
    filterFieldToggler.setRadioByName(value, attr);
    var _getValuesFromFields2 = getValuesFromFields(),
      inputsCheckbox = _getValuesFromFields2.inputsCheckbox,
      cat = _getValuesFromFields2.cat,
      inputMin = _getValuesFromFields2.inputMin,
      inputMax = _getValuesFromFields2.inputMax;
    var designers = getInputsValues(inputsCheckbox, 'name');
    var params = {
      designers: designers,
      inputMin: inputMin,
      inputMax: inputMax,
      cat: cat
    };
    multiFilterInstanse.ajaxFilterProducts(actions.filterproduct, filter_params.ajax_nonce, params);
  });
  if (!rangeSlider) {
    rangeSlider(function (_ref3) {
      var inputMin = _ref3.inputMin,
        inputMax = _ref3.inputMax;
      var _getValuesFromFields3 = getValuesFromFields(),
        inputsCheckbox = _getValuesFromFields3.inputsCheckbox,
        cat = _getValuesFromFields3.cat;
      var designers = getInputsValues(inputsCheckbox, 'name');
      var params = {
        designers: designers,
        inputMin: inputMin,
        inputMax: inputMax,
        cat: cat
      };
      multiFilterInstanse.ajaxFilterProducts(actions.filterproduct, filter_params.ajax_nonce, params);
    });
  }
  if (loadmoreContainer) {
    document.querySelector('body').addEventListener('click', function (e) {
      console.log('click');
      var targetButton = e.target;
      if (targetButton.classList.contains(loadmoreSelector)) {
        e.preventDefault();
        var _getValuesFromFields4 = getValuesFromFields(),
          inputsCheckbox = _getValuesFromFields4.inputsCheckbox,
          cat = _getValuesFromFields4.cat,
          inputMin = _getValuesFromFields4.inputMin,
          inputMax = _getValuesFromFields4.inputMax;
        var designers = getInputsValues(inputsCheckbox, 'name');
        var maxPage = targetButton.dataset.maxPage;
        var nextPage = targetButton.dataset.nextPage;
        var params = {
          designers: designers,
          inputMin: inputMin,
          inputMax: inputMax,
          cat: cat,
          maxPage: maxPage,
          nextPage: nextPage
        };
        multiFilterInstanse.ajaxLoadMore(actions.moreproduct, filter_params.ajax_nonce, params);
      }
    });
  }
}
export default init;